// Generated by CoffeeScript 2.7.0
var Admin__Settings__CustomerServiceController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js';

import SettingsCustomerService from 'trunks/vue/admin/components/settings/settings_container/settings_customer_service.js';

export default Admin__Settings__CustomerServiceController = (function() {
  class Admin__Settings__CustomerServiceController extends Skylark.App.BaseController {
    show() {
      this._generateSettingsSidebarView('settings__basic');
      return Skylark.Libs.Ajax.get('/admin/settings/customer_service.json', {
        success: function(data) {
          return new SettingsCustomerService({
            el: DomMaster.find("#js-settings-customer_service").node,
            propsData: {
              activeTab: 'customer_service',
              customerService: data
            }
          });
        }
      });
    }

  };

  Admin__Settings__CustomerServiceController.include(GenerateMorePopover);

  Admin__Settings__CustomerServiceController.include(SettingsNavigator);

  return Admin__Settings__CustomerServiceController;

}).call(this);
